export const AUTH_TOKEN_LABELS = {
	authenticationErrorTitle: 'Authentication Error'
};
